import { API_URL } from "../utils/AppApiUrl";
import { post } from "../utils/httpClients-methods";
import tokenHttpClient from "../utils/httpClient";

export const getNoOfVehicleCount = async (baseUrl, request = {}) => {
  const APIURL = `${baseUrl}${API_URL.noOfVehicleCount}`;

  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const getVehicleTypeCall = async (baseUrl, request = {}) => {
  const APIURL = `${baseUrl}${API_URL.vehicalTypeListUrl}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const getMaterialTypeCall = async (baseUrl, request = {}) => {
  const APIURL = `${baseUrl}${API_URL.materialTypeListUrl}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const getAppointmentCount = async (baseUrl, request = {}) => {
  const APIURL = `${baseUrl}${API_URL.appointmentCount}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const VendorAppointmentSubmit = async (baseUrl, request) => {
  const APIURL = `${baseUrl}${API_URL.vendorAppoitmentSubmitUrl}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    throw error;
  }
};

export const VendorAppointmentUpdate = async (baseUrl, request) => {
  const APIURL = `${baseUrl}${API_URL.vendorAppoitmentUpdateUrl}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    throw error;
  }
};

export const VendorAppointmentBook = async (request) => {
  const APIURL = `${API_URL.VendorAppointmentBook}`;
  try {
    const response = await post(request, APIURL, "");
    if (response.response === undefined) {
      return response;
    } else {
      return response.response;
    }
  } catch (error) {
    throw error;
  }
};

export const VendorAppointmentCancel = async (baseUrl, request) => {
  const APIURL = `${baseUrl}${API_URL.vendorAppoitmentCancelUrl}?appointmentId=${request?.appointmentId}`;
  try {
    const response = await post(tokenHttpClient, APIURL, request);
    if (response?.status === 200 && response.data) {
      return response?.data;
    } else {
      return {};
    }
  } catch (error) {
    throw error;
  }
};

export const VendorAppointmentCheckWithNewData = async (
  baseUrl,
  requestBody
) => {
  const APIURL = `${baseUrl}${API_URL.validateSlot}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(requestBody)
    );
    if (response?.status === 200 && response.data) {
      return response?.data;
    } else {
      return {};
    }
  } catch (error) {
    throw error;
  }
};

export const searchAppointmentsBySmartSearch = async (baseURL, requestBody) => {
  try {
    const searchResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.searchAppointmentbByValueUrl}`,
      JSON.stringify(requestBody)
    );
    if (searchResponse?.status === 200) {
      return searchResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const fetchTimeSlot = async (baseURL, requestBody) => {
  try {
    const fetchTimeSlotResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.fetchTimeSlot}`,
      JSON.stringify(requestBody)
    );
    if (fetchTimeSlotResponse?.status === 200) {
      return fetchTimeSlotResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const fetchTimeSlotFromCentral = async (baseURL, requestBody) => {
  try {
    const fetchTimeSlotResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.fetchTimeSlotCentral}`,
      JSON.stringify(requestBody)
    );
    if (fetchTimeSlotResponse.status === 200) {
      return fetchTimeSlotResponse.data;
    }else {
      return {};
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const verifyFCService = async (baseURL, requestBody) => {
  try {
    const verifyFCResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.verifyFC}`,
      JSON.stringify(requestBody)
    );

    if (verifyFCResponse.status === 200 && verifyFCResponse.data) {
      return verifyFCResponse.data;
    } else {
      return [];
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const reserveTimeSlot = async (baseURL, requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.reserveTimeSlot}`,
      JSON.stringify(requestBody)
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};
